import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '@/lib/supabase'

export function PacienteEntryPage() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const [status, setStatus] = useState<'validando' | 'valido' | 'invalido'>('validando')
  const [consulta, setConsulta] = useState<any>(null)

  useEffect(() => {
    async function validarToken() {
      if (!token) {
        setStatus('invalido')
        return
      }

      try {
        const { data, error } = await supabase.functions.invoke('validar-token-publico', {
          body: { token }
        })

        if (error || !data?.valido) {
          setStatus('invalido')
          return
        }

        setConsulta(data.consulta)
        setStatus('valido')

        // Redirecionar para verificação técnica após 2 segundos
        setTimeout(() => {
          navigate(`/teleconsulta/${token}/verificacao`)
        }, 2000)
      } catch {
        setStatus('invalido')
      }
    }

    validarToken()
  }, [token, navigate])

  if (status === 'validando') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-muted-foreground">Validando acesso...</p>
        </div>
      </div>
    )
  }

  if (status === 'invalido') {
    return (
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="text-center">
          <div className="mb-4 text-6xl">🔒</div>
          <h1 className="mb-2 text-xl font-semibold">Link inválido ou expirado</h1>
          <p className="text-muted-foreground">
            Entre em contato com a ILPI para obter um novo link de acesso.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center">
        <div className="mb-4 text-6xl">✅</div>
        <h1 className="mb-2 text-xl font-semibold">Acesso validado</h1>
        <p className="text-muted-foreground">
          Consulta com {consulta?.medicoNome || 'Dr(a).'} — {consulta?.pacienteNome || 'Paciente'}
        </p>
        <p className="mt-2 text-sm text-muted-foreground">Redirecionando...</p>
      </div>
    </div>
  )
}
